export enum AddTransactionType {
  Manual = 'Manual',
  FiftyMileCharge = 'FiftyMileCharge',
  FiftyMileSinceOdometer = 'FiftyMileSinceOdometer',
}
